import { Directive, Input, OnInit, TemplateRef, ViewContainerRef } from '@angular/core';

@Directive({
    selector: '[casOnceNgIf]'
})
export class OnceNgIfDirective implements OnInit {

    @Input() public casOnceNgIf: boolean | any;

    constructor(
        private templateRef: TemplateRef<any>,
        private viewContainer: ViewContainerRef) {
    }

    public ngOnInit() {
        if (this.casOnceNgIf) {
            this.viewContainer.createEmbeddedView(this.templateRef);
        } else {
            this.viewContainer.clear();
        }
    }
}
